import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, eur, fmtDateTime } from "../lib/api";
import { Field } from "./common";

const ROWS = [
  ["ups", "Facturé UPS"], ["sub", "Sous-traitants (hors Touré)"], ["toure", "Touré (TOURE / shuttles)"], ["benefit", "Bénéfice"],
  ["idris_benefit", "Idris · part du bénéfice"], ["idris_toure", "Idris · part sur Touré"], ["toure_benefit", "Touré · part du bénéfice"], ["toure_own", "Touré · part de ses prestations"],
];

export function SplitBlock({ range }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/dashboard/split", { params: { date_from: range.from || undefined, date_to: range.to || undefined } }).then((r) => setD(r.data));
  }, [range]);
  if (!d) return null;
  const pct = (v) => `${Math.round(v * 1000) / 10} %`;
  return (
    <div className="tl-card mb-5 overflow-x-auto" data-testid="split-block">
      <h3 className="font-bold uppercase">Répartition Idris / Touré</h3>
      <p className="text-xs text-slate-500 mb-2">Règles : Idris {pct(d.rules.share_idris)} du bénéfice + {pct(d.rules.toure_idris_pct)} de la part Touré · TOURE BP à {d.rules.bp_pct} % du tarif UPS. Montants connus uniquement.</p>
      <table className="tl-table">
        <thead><tr><th /><th>Semaine</th><th>Samedi</th><th>Total</th></tr></thead>
        <tbody>
          {ROWS.map(([k, l]) => (
            <tr key={k} data-testid={`split-row-${k}`}><td className="font-semibold">{l}</td><td className="tl-mono">{eur(d.semaine[k])}</td><td className="tl-mono">{eur(d.samedi[k])}</td><td className="tl-mono">{eur(d.semaine[k] + d.samedi[k])}</td></tr>
          ))}
          {[["idris", "TOTAL IDRIS"], ["toure_total", "TOTAL TOURÉ"]].map(([k, l]) => (
            <tr key={k} className="bg-amber-50 font-bold" data-testid={`split-total-${k}`}><td>{l}</td><td className="tl-mono">{eur(d.semaine[k])}</td><td className="tl-mono">{eur(d.samedi[k])}</td><td className="tl-mono">{eur(d.semaine[k] + d.samedi[k])}</td></tr>
          ))}
        </tbody>
      </table>
      {d.semaine.tbc + d.samedi.tbc > 0 && <p className="text-xs text-amber-700 mt-2">{d.semaine.tbc + d.samedi.tbc} montant(s) à confirmer non inclus.</p>}
    </div>
  );
}

const fmtRules = (r) => (r ? `Idris ${Math.round(r.share_idris * 1000) / 10} % · sur Touré ${Math.round(r.toure_idris_pct * 1000) / 10} % · BP ${r.bp_pct} %` : "—");

function RulesHistory({ rows }) {
  return (
    <div className="border-t pt-3" data-testid="split-rules-history">
      <h4 className="font-bold uppercase text-sm mb-2">Historique des modifications</h4>
      {!rows.length && <p className="text-sm text-slate-500">Aucune modification enregistrée.</p>}
      <table className="tl-table text-sm">
        <tbody>
          {rows.map((h) => (
            <tr key={h.id} data-testid={`split-history-${h.id}`}>
              <td className="whitespace-nowrap">{fmtDateTime(h.at)}</td><td className="font-semibold">{h.author_name}</td>
              <td><span className="line-through text-slate-500">{fmtRules(h.old)}</span><div>{fmtRules(h.new)}</div></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function SplitRulesPanel() {
  const [f, setF] = useState(null);
  const [hist, setHist] = useState([]);
  const loadHist = () => api.get("/audit/split_rules").then((r) => setHist(r.data));
  useEffect(() => {
    api.get("/settings/split-rules").then((r) => setF({ share: r.data.share_idris * 100, tpct: r.data.toure_idris_pct * 100, bp: r.data.bp_pct }));
    loadHist();
  }, []);
  if (!f) return null;
  const save = async () => {
    try {
      const { data } = await api.put("/settings/split-rules", { share_idris: Number(f.share) / 100, toure_idris_pct: Number(f.tpct) / 100, bp_pct: Number(f.bp) });
      toast.success(`Règles enregistrées${data.recalculated ? ` · ${data.recalculated} prestation(s) TOURE BP recalculée(s)` : ""}`);
      loadHist();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const inp = (k, testid) => <input type="number" step="0.1" className="tl-input" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={testid} />;
  return (
    <div className="tl-card max-w-xl space-y-3" data-testid="split-rules-panel">
      <p className="text-sm text-slate-600">Bénéfice = UPS − sous-traitants − Touré. Visible et modifiable uniquement par l'administrateur.</p>
      <Field label="Part d'Idris dans le bénéfice (%)">{inp("share", "split-share-input")}</Field>
      <Field label="Part d'Idris sur la part Touré (%)">{inp("tpct", "split-toure-pct-input")}</Field>
      <Field label="TOURE BP (Billy / Pierre) : % du tarif UPS payé">{inp("bp", "split-bp-input")}</Field>
      <p className="text-xs text-slate-500">Modifiable à tout moment. Un changement du % TOURE BP recalcule automatiquement les prestations Billy / Pierre non validées des périodes ouvertes.</p>
      <button className="tl-btn tl-btn-primary" onClick={save} data-testid="split-rules-save">Enregistrer</button>
      <RulesHistory rows={hist} />
    </div>
  );
}
